import PropTypes from 'prop-types';

import ValidationBullet from './ValidationBullet';

const ValidationsTooltip = ({ title, conditions }) => (
  <div className="validations-tooltip">
    <p className="bold-text mb-2" style={{ fontWeight: 800 }}>{title}</p>
    <div className="d-flex flex-column gap-10 tooltip-list">
      {conditions.map(({ condition, message }) => (
        <ValidationBullet key={message} condition={condition} message={message} />
      ))}
    </div>
  </div>
);

ValidationsTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  conditions: PropTypes.arrayOf(
    PropTypes.shape({
      condition: PropTypes.bool,
      message: PropTypes.string,
    })).isRequired,
};

export default ValidationsTooltip;
